import axios from './axios-instance'

export default {
  async askAi(contextType, contextId, prompt, chatId) {
    return axios.post('ai/chat', {
      context_type: contextType,
      context_id: contextId,
      prompt,
      ai_thread_uuid: chatId,
    })
  },

  async archiveThread(uuid) {
    return axios.delete(`ai/chat/${uuid}`)
  },

  async rateMessage(uuid, rating) {
    return axios.post(`ai/messages/${uuid}/rate`, {
      rating,
    })
  },
}
